import { createBrowserHistory } from 'history'

function History() {
  return createBrowserHistory()
}

export default History
